import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onNotificationOpened } from "./nativePush";

/**
 * Store app: a tapped reminder opens the page it names (the backend sends
 * /programs). Lives inside the router so it can navigate; renders nothing.
 * The plugin holds a tap that started the app until this listener exists.
 */
export default function NativePushLinks() {
  const navigate = useNavigate();
  useEffect(() => onNotificationOpened((url) => navigate(url)), [navigate]);
  return null;
}
